/* PawDent — רשת מוצרים: עיגולי צבע מחליפים תמונה ووריאנט, וכפתור מוסיף לעגלה. */
(function () {
  'use strict';

  function refreshCart(data) {
    if (data && data.sections && data.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
      try {
        drawer.renderContents(data);
        setTimeout(function () {
          if (!document.querySelector('#CartDrawer .cart-item')) {
            try { sessionStorage.setItem('pdbbOpenCart', '1'); } catch (err) {}
            window.location.reload();
          }
        }, 300);
        return;
      } catch (e) {}
    }
    window.location.reload();
  }

  function bindCard(card) {
    if (card.dataset.pcardInit) return;
    card.dataset.pcardInit = '1';

    var img = card.querySelector('[data-pcard-img]');
    var label = card.querySelector('[data-pcard-label]');
    var swatches = card.querySelectorAll('[data-pcard-swatch]');
    var atc = card.querySelector('[data-pcard-atc]');

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (img && btn.dataset.img) {
          img.src = btn.dataset.img;
          if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
        }
        if (label && btn.dataset.label) label.textContent = btn.dataset.label;
        /* הצבע הנבחר קובע גם איזה וריאנט הכפתור יוסיף */
        if (atc && btn.dataset.variantId) atc.dataset.variantId = btn.dataset.variantId;
        swatches.forEach(function (other) {
          other.classList.remove('pcard__swatch--current');
        });
        btn.classList.add('pcard__swatch--current');
      });
    });

    if (atc) {
      atc.addEventListener('click', function () {
        var vid = Number(atc.dataset.variantId);
        if (!vid) return;
        atc.classList.add('pcard__atc--loading');
        var body = { items: [{ id: vid, quantity: 1 }] };
        var names = [];
        if (document.querySelector('cart-drawer')) names.push('cart-drawer');
        if (document.getElementById('cart-icon-bubble')) names.push('cart-icon-bubble');
        if (names.length) {
          body.sections = names;
          body.sections_url = window.location.pathname;
        }
        var addUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            atc.classList.remove('pcard__atc--loading');
            if (r.ok) refreshCart(r.data);
          })
          .catch(function () { atc.classList.remove('pcard__atc--loading'); });
      });
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.pcard').forEach(function (card) {
      try { bindCard(card); } catch (err) { console.error('pcard init', err); }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
